import { SilentError } from './SilentError';
/**
 * @throws {Error}
 */
export const throwGlobal = (error, { context } = {}) => {
    if (error instanceof SilentError) {
        return;
    }
    if (context != null) {
        Error.captureStackTrace?.(error, context);
    }
    error.scope = 'global';
    setTimeout(() => {
        throw error;
    });
};

